import useReveal from '../hooks/useReveal';
import { BrowserFrame, PhoneFrame } from './Devices';
import consoleScreen from '../assets/images/web1.jpg';
import shareScreen from '../assets/images/mobile3.jpg';

export default function ProductShowcase() {
  const [ref, isRevealed] = useReveal(0.1);

  return (
    <section className={`showcase ${isRevealed ? 'is-revealed' : ''}`} ref={ref}>
      <div className="showcase__header reveal">
        <h2 className="section-title">Your memories, on every screen.</h2>
        <p className="section-lead">
          Hosts run the collection from the web console. Guests scan, upload, and watch the
          album fill up.
        </p>
      </div>

      <div className="showcase__stage reveal">
        <BrowserFrame
          className="showcase__browser"
          src={consoleScreen}
          url="console.shareshutter.com"
          alt="The ShareShutter web console showing a collection gallery of event photos and videos"
        />
        <PhoneFrame
          className="showcase__phone"
          src={shareScreen}
          alt="The ShareShutter share sheet on a phone, showing the QR code guests scan to join a collection"
        />
      </div>
    </section>
  );
}
